import { render, staticRenderFns } from "./SystemTextMessage.vue?vue&type=template&id=141223f0&scoped=true"
import script from "./SystemTextMessage.vue?vue&type=script&lang=js"
export * from "./SystemTextMessage.vue?vue&type=script&lang=js"
import style0 from "./SystemTextMessage.vue?vue&type=style&index=0&id=141223f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141223f0",
  null
  
)

export default component.exports